import React, { useState, useRef, useEffect } from "react";

export const CustomCountDropdownPopup = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const options = [10, 20, 50];
  const dropdownRef = useRef();

  // Close popup on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer px-2 py-1 border border-blue-600 w-20 rounded text-sm bg-white text-left"
      >
        {value}
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-1 bg-white border border-gray-300 shadow-md w-20 rounded-md">
          {options.map((opt) => (
            <div
              key={opt}
              onClick={() => {
                onChange(opt);
                setIsOpen(false);
              }}
              className={`cursor-pointer px-2 py-1 text-sm ${
                value == opt ? "bg-[#245cea] text-white" : ""
              }
               ${
                 opt === 10
                   ? "hover:bg-[#245cea] hover:text-white rounded-t-md"
                   : ""
               }
                ${
                  opt === 50
                    ? "hover:bg-[#245cea] hover:text-white rounded-b-md"
                    : ""
                }
              ${
                opt === 20
                  ? "hover:bg-[#245cea] hover:text-white"
                  : ""
              }
              `}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
